
import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './pages/AdminPortal/Login';
import StudentReg from './pages/AdminPortal/StudentReg';
import TeacherReg from './pages/AdminPortal/TeacherReg';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import DashboardTeacherPortal from './components/TeacherPortal/DashboardTeacherPortal';
import AssignedEssays from './pages/TeachersPortal/AssignedEssays';
import EssaysDetailsTeacher from './pages/TeachersPortal/EssaysDetails';
import DashboardStudentPortal from './components/StudentPortal/DashboardStudentPortal';
import StudentsDetails from './pages/AdminPortal/StudentsDetails';
import AssignmentsDetails from './pages/AdminPortal/AssignmentsDetails';
import HomePage from './pages/HomePage'
import './App.css'
function App() {
  useEffect(() => {
    document.body.style.fontFamily = "bahnschrift";
  }, []);

  return (
    <>
      <Router>
        <Routes>
        {/* login register routes */}
        
        <Route path="/" element={<HomePage/>} />
        
         <Route path="/login" element={<Login />} />
          <Route path="/student-register" element={<StudentReg />} />
          <Route path="/teacher-register" element={<TeacherReg />} />
        {/* admin portal */}
       
          <Route path="/admin-portal/*" element={<Dashboard />} />

          {/* Teachers Portal Routes */}
          <Route path="/teachers-portal/*" element={<DashboardTeacherPortal />} />

          {/* Student Portal Routes */}
          <Route path="/students-portal/*" element={<DashboardStudentPortal />} /> {/* Add nested route */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
